import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: '',
      });
    }
  };

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!formData.name) formErrors.name = 'Name is required';
    if (!formData.email) formErrors.email = 'Email is required';
    else if (!validateEmail(formData.email)) formErrors.email = 'Invalid email address';
    if (!formData.message) formErrors.message = 'Message is required';

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_USER_ID
      ).then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          setFormData({
            name: '',
            email: '',
            message: '',
          });
          alert('Gracias por tu mensaje!');
        },
        (err) => {
          console.error('FAILED...', err);
          alert('¡Oops! Algo salió mal. Por favor, inténtalo de nuevo.');
        }
      );
    }
  };

  return (
    <div className="wrapper">
      <Header />
      <main className="main-content contact-us">
        <h2>Contacto</h2>
        <p>Nos encantaría saber de ti. Por favor, completa el formulario a continuación y nos pondremos en contacto contigo lo antes posible.</p>
        <div className="contact-container">
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <label htmlFor="name">Nombre</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Tu nombre"
                value={formData.name}
                onChange={handleChange}
                required
              />
              {errors.name && <p className="error">{errors.name}</p>}
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Tu email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              {errors.email && <p className="error">{errors.email}</p>}
              <label htmlFor="message">Mensaje</label>
              <textarea
                id="message"
                name="message"
                placeholder="Tu mensaje"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              {errors.message && <p className="error">{errors.message}</p>}
              <button type="submit">Enviar</button>
            </form>
          </div>
          <div className="contact-info">
            <h3>Información de Contacto</h3>
            <p>Dirección: Paseo Garcia Faria 81, Barcelona, España</p>
            <p>Teléfono: (123) 456-7890</p>
            <p>Email: info@skylightcapital.com</p>
            <div className="map">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2994.711724276399!2d2.2030569157097195!3d41.4012468792636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4a30950948b1b%3A0x8c5b33be5e6332a8!2sPasseig%20de%20Garcia%20F%C3%A0ria%sPasseig%20de%20Garcia%20F%C3%A0ria%2C%2081%2C%2008003%20Barcelona%2C%20Spain!5e0!3m2!1sen!2sus!4v1614592421456!5m2!1sen!2sus" 
                width="100%" 
                height="300" 
                frameBorder="0" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                aria-hidden="false" 
                tabIndex="0"
                title="Ubicación de Skylight Capital"
              ></iframe>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;

